<template>
<v-flex>
    <h1 style="color: #969462 !important;">Extratos de Conta</h1>
    <v-dialog v-model="loader" persistent width="350">
        <v-card color="#969462" dark>
            <v-card-text>
                Esta operação pode demorar alguns minutos.<br>
                Por favor aguarde...
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
    <v-flex xs12 sm12 md12>
        <v-layout row wrap>
            <v-flex v-if="getSession.user.super == 1" xs3 sm3 md3>
                <label class="label-modal">Cliente</label>
                <v-autocomplete color="#969462" :items="getClientes" v-model="cliente" @change="setAnos()" item-text="nome" item-value="codigo"></v-autocomplete>
            </v-flex>
            <v-flex xs3 sm3 md3 v-bind:class="getSession.user.super == 1 ? 'pl-5' : ''">
                <label class="label-modal">Ano</label>
                <v-autocomplete color="#969462" :items="anos" @change="changeAno" v-model="ano"></v-autocomplete>
            </v-flex>
            <v-flex xs3 sm3 md3 class="pl-5">
                <label class="label-modal">Data ínicio</label>
                <v-menu :close-on-content-click="false" v-model="iniMenu" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                    <v-text-field slot="activator" color="#969462" v-model="ini" readonly></v-text-field>
                    <v-date-picker locale="pt-pt" color="#969462" v-model="ini" @input="iniMenu = false" @change="()=>{this.isIni = this.ini ? true : false}"></v-date-picker>
                </v-menu>
            </v-flex>
            <v-flex xs3 sm3 md3 class="pl-5">
                <label class="label-modal">Data fim</label>
                <v-menu :close-on-content-click="false" v-model="fimMenu" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                    <v-text-field slot="activator" color="#969462" v-model="fim" readonly></v-text-field>
                    <v-date-picker locale="pt-pt" color="#969462" :min="ini" v-model="fim" @input="fimMenu = false" @change="()=>{this.isFim = this.fim ? true : false}"></v-date-picker>
                </v-menu>
            </v-flex>
            <v-flex xs3 sm3 md3 v-if="ano" v-bind:class="getSession.user.super == 1 ? '':'pl-5'">
                <label class="label-modal">Tipo de pesquisa</label>
                <v-radio-group color="#969462" v-model="isLista" row>
                    <v-radio color="#969462" label="Intervalo contas" value="1"></v-radio>
                    <v-radio color="#969462" label="Múltiplas contas" value="2"></v-radio>
                </v-radio-group>
            </v-flex>
            <!-- <v-flex xs3 sm3 md3 class="pl-5">
                <label class="label-modal">Data ínicio</label>
                <v-menu :close-on-content-click="false" v-model="iniMenu" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                    <v-text-field slot="activator" color="#969462" v-model="ini" :prepend-icon="isIniIcon" @click:prepend="isIniChange" readonly></v-text-field>
                    <v-date-picker locale="pt-pt" color="#969462" v-model="ini" @input="iniMenu = false" @change="()=>{this.isIni = this.ini ? true : false}"></v-date-picker>
                </v-menu>
            </v-flex>
            <v-flex xs3 sm3 md3 class="pl-5">
                <label class="label-modal">Data fim</label>
                <v-menu :close-on-content-click="false" v-model="fimMenu" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                    <v-text-field slot="activator" color="#969462" v-model="fim" :prepend-icon="isFimIcon" @click:prepend="isFimChange" readonly></v-text-field>
                    <v-date-picker locale="pt-pt" color="#969462" :min="ini" v-model="fim" @input="fimMenu = false" @change="()=>{this.isFim = this.fim ? true : false}"></v-date-picker>
                </v-menu>
            </v-flex> -->
            <v-flex v-if="isLista == 1 && ano" xs3 sm3 md3>
                <label class="label-modal">Conta ínicio</label>
                <v-combobox color="#969462" v-model="cinicio" @input="changeCI" chips clearable>
                    <template v-slot:selection="data">
                        <v-chip :selected="data.selected" close @input="removeCI(data.item)">
                            <strong>{{ data.item }}</strong>
                        </v-chip>
                    </template>
                </v-combobox>
            </v-flex>
            <v-flex v-if="isLista == 1 && ano" xs3 sm3 md3 class="pl-5">
                <label class="label-modal">Conta fim</label>
                <v-combobox color="#969462" v-model="cfim" @input="changeCF" chips clearable>
                    <template v-slot:selection="data">
                        <v-chip :selected="data.selected" close @input="removeCF(data.item)">
                            <strong>{{ data.item }}</strong>
                        </v-chip>
                    </template>
                </v-combobox>
            </v-flex>
            <v-flex v-if="isLista == 2 && ano" xs6 sm6 md6>
                <label class="label-modal">Lista contas</label>
                <v-combobox color="#969462" v-model="listacontas" @input="changeLC" chips clearable multiple>
                    <template v-slot:selection="data">
                        <v-chip :selected="data.selected" close @input="removeLC(data.item)">
                            <strong>{{ data.item }}</strong>
                        </v-chip>
                    </template>
                </v-combobox>
            </v-flex>
            <v-flex xs3 sm3 md3 v-if="getSession.user.super == 0 || (getSession.user.super == 1 && ano)" style="position: relative;">
                <v-btn @click="searchData" dark color="#969462" class="btnSearch">Pesquisar</v-btn>
            </v-flex>
        </v-layout>
    </v-flex>
    <div class="elevation-3">
        <div class="tableHeader">
            <v-flex xs12 sm12 md12>
                <v-layout row wrap>
                    <v-flex xs8 sm8 md8 justify-start align-center d-flex>
                        <v-autocomplete color="#969462" :items="CONTAS" @change="changeConta" v-model="CONTA"></v-autocomplete>
                        <v-autocomplete class="ml-2 mr-2" color="#969462" :items="SUBCONTAS" item-text="key" item-value="key" @change="changeSubConta" v-model="SUBCONTA"></v-autocomplete>
                        <v-btn dark @click="generatePdf()" color="#969462">Exportar</v-btn>
                        <v-btn dark @click="generatePdfAll()" color="#969462">Exportar tudo</v-btn>
                    </v-flex>
                    <v-flex xs2 sm2 md2>
                    </v-flex>
                    <v-flex xs2 sm2 md2 justify-end d-flex>
                        <v-text-field color="#969462" class="searchTable" v-model="search" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
                    </v-flex>
                </v-layout>
            </v-flex>
        </div>
        <v-data-table :headers="headers" :items="DATA" :search="search" :loading="loading" item-key="id" :disable-initial-sort="true" color="#969462" :rows-per-page-items='[50,150,300,{"text":"Todos","value":-1}]' rows-per-page-text="Itens por página:">
            <template slot="items" slot-scope="props">
                <td class="textLeft">{{props.item.datamov || '-'}}</td>
                <td class="textLeft">{{props.item.diario || '-'}}</td>
                <td class="textLeft">{{props.item.numinterno || '-'}}</td>
                <td class="textLeft">{{props.item.descricaolancamento || '-'}}</td>
                <td class="textLeft">{{props.item.documento || '-'}}</td>
                <td class="textLeft">{{props.item.observacoes || '-'}}</td>
                <td class="textRight">{{numberWithSpaces(props.item.debito || '-')}}</td>
                <td class="textRight">{{numberWithSpaces(props.item.credito) || '-'}}</td>
                <td class="textRight">{{numberWithSpaces(props.item.saldo) || '-'}}</td>
            </template>
            <template v-if="DATA.length" slot="footer">
                <td class="textCenter" colspan="6"><strong>Total</strong></td>
                <td class="textRight"><strong>{{numberWithSpaces(getTotalByProperty('debito'))}}</strong></td>
                <td class="textRight"><strong>{{numberWithSpaces(getTotalByProperty('credito'))}}</strong></td>
                <td class="textRight"><strong>{{numberWithSpaces(getTotalByProperty('saldo'))}}</strong></td>
            </template>
            <template v-else slot="footer">
                <td class="textLeft" colspan="7"><strong>Total</strong></td>
                <td class="textRight"><strong>0</strong></td>
                <td class="textRight"><strong>0</strong></td>
                <td class="textRight"><strong>0</strong></td>
            </template> 

            <template class="alertTable" slot="no-data">
                <v-alert :value="true" icon="warning">
                    De momento não há nada a apresentar! :(
                </v-alert>
            </template>
        </v-data-table>

    </div>
</v-flex>
</template>

<script>
import {
    mapState,
    mapGetters,
    mapActions
} from "vuex";

import axios from 'axios';
import qs from 'qs';
import convert from "xml-js";
import * as d3 from "d3";

const cName = {
    upper: "Extrato de conta",
    lower: "o extrato de conta!"
};

export default {
    data: () => ({
        table: 'utilizadores',
        name: 'extrato',
        search: "",
        loading: false,
        loader: false,
        searchP: '',
        headers: [{
                text: "Data",
                align: "left",
                sortable: true,
                value: "datamov"
            },
            {
                text: "Diário",
                align: "left",
                sortable: true,
                value: "diario"
            },
            {
                text: "Nº Int.",
                align: "left",
                sortable: true,
                value: "numinterno"
            },
            {
                text: "Descrição",
                align: "left",
                sortable: true,
                value: "descricaolancamento"
            },
            {
                text: "Documento",
                align: "left",
                sortable: true,
                value: "documento"
            },
            {
                text: "Obs",
                align: "left",
                sortable: true,
                value: "observacoes",
            },
            {
                text: "Débito €",
                align: "right",
                sortable: true,
                value: "debito"
            },
            {
                text: "Crédito €",
                align: "right",
                sortable: true,
                value: "credito"
            },
            {
                text: "Saldo €",
                align: "right",
                sortable: true,
                value: "saldo",
            }
        ],
        anos: [],
        DATA: [],
        iniMenu: false,
        ini: '',
        fimMenu: false,
        fim: '',
        isIni: false,
        isFim: false,
        isLista: '1',
        cliente: '',
        ano: '',
        cinicio: '',
        cfim: '',
        listacontas: '',
        timer: null,
        STATS: [],
        SUBCONTAS: [],
        CONTAS: [],
        SUBCONTA: '',
        CONTA: '',
        messages: {
            add: {
                success: cName.upper + " criado com sucesso!",
                error: "Ocorreu um erro ao criar " + cName.lower
            },
            update: {
                success: cName.upper + " alterado com sucesso!",
                error: "Ocorreu um erro ao alterar " + cName.lower
            },
            delete: {
                success: cName.upper + " eliminado com sucesso!",
                error: "Ocorreu um erro ao apagar " + cName.lower
            },
            default: {
                sucesso: "Sucesso",
                error: "Ocorreu um erro!"
            }
        }
    }),

    computed: {
        ...mapGetters({
            getSession: 'session/getState',
            getClientes: 'utilizadores/getClientes',
            getContasByCodigo: 'contas/getContasByCodigo',
            getClienteByCodigo: 'utilizadores/getClienteByCodigo',
            getLinks: 'session/getLinks'
        }),
        isIniIcon() {
            return this.isIni ? "check_box" : "check_box_outline_blank";
        },
        isFimIcon() {
            return this.isFim ? "check_box" : "check_box_outline_blank";
        },
    },

    watch: {},

    created() {
        //this.ano = Number(this.$moment().format('YYYY'));
        if (this.getSession.user.super == 0) this.cliente = this.getSession.user.codigo;

        setTimeout(() => {
            try {
                this.setAnos();
            } catch (error) {
                setTimeout(() => {
                    try {
                        this.setAnos();
                    } catch (error) {
                    }
                }, 500);
            }
        }, 500);
    },
    methods: {
        setAnos() {
            if (this.getSession.user.super == 0) this.anos = this.getSession.user.anos;
            else this.anos = this.getClienteByCodigo(this.cliente).anos;
        },

        numberWithSpaces(x) {
            var parts = x.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return parts.join(".");
        },

        toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },

        generatePdfAll() {
            if(this.STATS.length == 0) return;
            
            this.loader = true;
            var cliente = this.getClienteByCodigo(this.cliente);
            var nome = this.$moment().unix();
            this.$store.dispatch('contas/generatePdfExtratoAll', {
                data: this.STATS,
                cliente: cliente.codigo+' - '+cliente.nome,
                nif: cliente.nif,
                nome: nome,
                inicio: this.ini,
                fim: this.fim
            }).then((res)=>{
                if(res) window.open(this.$pdfURL+nome+'.pdf', '_blank');
                else this.toast('error', 'Ocorreu um erro ao exportar.');

                this.loader = false;
            })
        },

        generatePdf() {
            if(this.DATA.length == 0) return;
            
            this.loader = true;
            var cliente = this.getClienteByCodigo(this.cliente);
            var nome = this.$moment().unix();
            this.$store.dispatch('contas/generatePdfExtrato', {
                data: this.STATS.find((el)=>{ return el.key == this.SUBCONTA}),
                cliente: cliente.codigo+' - '+cliente.nome,
                nif: cliente.nif,
                nome: nome,
                inicio: this.ini,
                fim: this.fim
            }).then((res)=>{
                if(res) window.open(this.$pdfURL+nome+'.pdf', '_blank')
                else this.toast('error', 'Ocorreu um erro ao exportar.');

                this.loader = false;
            })
        },

        getTotalByProperty(prop) {
            if(this.DATA.length==0) return 0

            if(prop === 'saldo') return Math.max.apply(Math,this.DATA.map((el)=>{ return parseFloat(String(el[prop]).replace(',','.')) })).toFixed(2) + ' €';
            else return this.DATA.map((el)=>{ return el[prop] }).reduce((a,b)=>(parseFloat(String(a).replace(',','.'))+parseFloat(String(b).replace(',','.'))).toFixed(2)) + ' €'
        },

        getTotalByPropArray(array, prop) {
            if(prop === 'saldo') return Math.max.apply(Math,array.map((el)=>{ return parseFloat(String(el[prop]).replace(',','.')) })).toFixed(2) + ' €';
            else return array.map((el)=>{ return el[prop] }).reduce((a,b)=>(parseFloat(String(a).replace(',','.'))+parseFloat(String(b).replace(',','.'))).toFixed(2)) + ' €';
        },

        isIniChange() {
            this.isIni = !this.isIni;
        },
        isFimChange() {
            this.isFim = !this.isFim;
        },

        changeCI() {
            if(!this.cinicio) return;

            this.getContasByCodigo(this.cinicio).then((res) => {
                if (res.length == 0) { this.toast('error', 'Conta inexistente.'); this.removeCI();}
            })
        },

        changeCF() {
            if(!this.cfim) return;

            this.getContasByCodigo(this.cfim).then((res) => {
                if (res.length == 0 || (this.cfim <= this.cinicio)) { this.toast('error', 'Conta inexistente.'); this.removeCF();}
            })
        },

        changeLC() {
            if(this.listacontas.length == 0) return;

            this.getContasByCodigo(this.listacontas[this.listacontas.length - 1]).then((res) => {
                if (res.length == 0) {this.toast('error', 'Conta inexistente.'); this.removeLC(this.listacontas.length - 1);}
            })
        },

        removeCI() {
            this.cinicio = null;
        },

        removeCF() {
            this.cfim = null;
        },

        removeLC(item) {
            this.listacontas.splice(this.listacontas.indexOf(item), 1)
            this.listacontas = [...this.listacontas]
        },

        StatPerConta(contas) {
            var value = d3
            .nest()
            .key(function (d) {
                return d.codigoconta + ' - ' + d.designacao;
            })
            .rollup((v) => {
                return {
                    dados: v,
                    totalDebito: this.getTotalByPropArray(v, 'debito'),
                    totalCredito: this.getTotalByPropArray(v, 'credito'),
                    totalSaldo: this.getTotalByPropArray(v, 'saldo'),
                    contaPrincipal: v[0].codcontaprincipal
                }
            })
            .entries(contas);
            return value;
        },

        changeSubConta() {
            this.DATA = this.STATS.find((el)=>{ return el.key == this.SUBCONTA }).value.dados;
        },

        changeConta() {
            this.SUBCONTAS = this.STATS.filter((el)=>{ return String(el.value.contaPrincipal) == String(this.CONTA) }).map((el)=>{ return el.key });
            this.SUBCONTA = this.SUBCONTAS[0];
            this.changeSubConta();
        },

        changeAno() {
            this.cinicio = '';
            this.cfim = '';
            this.listacontas = '';

            this.$store.dispatch('contas/clearData').then((res) => {
                this.$store.dispatch('contas/get', {
                    pwd: this.$servicePWD,
                    cliente: this.cliente,
                    ano: this.ano,
                    url: this.getLinks.contasURL
                });
            })
        },

        splitContas(array) {
            var aux = [];

            for(var a of array) if(aux.indexOf(a) == -1) aux.push(a);

            return aux;
        },

        searchData() {

            if (!this.ini || !this.fim) {
                this.toast('error', 'Intervalo de datas não definido.');
                return;
            } else if (this.isLista == 2 && this.listacontas == '') {
                this.toast('error', 'Deve escolher pelo menos uma conta.');
                return;
            } else if (this.isLista == 1 && (!this.cinicio || !this.cfim)) {
                this.toast('error', 'Intervalo de contas não definido.');
                return;
            }

            var url = this.getLinks.extratoURL;
            this.loader = true;
            const options = {
                timeout: 60000,
                method: 'POST',
                headers: {
                    'content-type': 'application/x-www-form-urlencoded'
                },
                data: qs.stringify({
                    invocationPassword: this.$servicePWD,
                    cliente: this.cliente,
                    ano: this.ano,
                    datainicio: this.ini,
                    datafim: this.fim,
                    containicio: this.isLista == 1 ? this.cinicio : '',
                    contafim: this.isLista == 1 ? this.cfim : '',
                    listacontas: this.isLista == 2 ? this.listacontas.join('|') : '',
                }),
                url,
            };

            axios(options).then(async (res) => {
                var result = JSON.parse(JSON.parse(convert.xml2json(res.data, {
                    compact: true,
                    spaces: 4
                })).string._text);

                var ARRAY = Array.isArray(result) ? result : [];

                if (ARRAY.length == 0) this.toast('error', 'Não foram encontrados resultados para a pesquisa efetuada.');
                else {
                    this.CONTAS = await this.splitContas(ARRAY.map((el)=>{ return el.codcontaprincipal })).sort((a,b)=>{ return Number(a) - Number(b) });
                    this.STATS = await this.StatPerConta(ARRAY).sort((a,b)=>{ return Number(a.key.split('-')[0].trim()) - Number(b.key.split('-')[0].trim()) });
                
                    this.CONTA = this.CONTAS[0];
                    this.changeConta();
                }

                this.loader = false;
            }).catch((err) => {
                this.loader = false;
                this.toast('error', 'Não foram encontrados resultados para a pesquisa efetuada.');
            })

        },
    }
}
</script>

<style scoped>
.btnSearch {
    position: absolute;
    bottom: 20%;
    width: 87%;
    margin-left: 12.5%;
}
</style>



// WEBPACK FOOTER //
// src/components/tables/Table_Extrato_Conta.vue